// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"037b748732a7b8ee","8195":"0a4f95abf596f117"}[chunkId] + ".css";
};